import {PtrnCrudHandlers} from '../patronProps';
import {
   PtrnAccionCancel,
   PtrnAccionDelete,
   PtrnAccionFn,
   PtrnAccionInsert,
   PtrnAccionUpdate,
   PtrnIcons
} from '../patronTypes';

export class PtrnAccionesFactory {
   static AccionCancelar(onCancel: PtrnAccionFn): PtrnAccionCancel {
      return {
         label: 'Cancelar',
         icon: PtrnIcons.cancel,
         fn: onCancel
      };
   }
   static AccionDelete(onDelete: PtrnAccionFn): PtrnAccionDelete {
      return {
         label: 'Eliminar',
         icon: PtrnIcons.delete,
         fn: onDelete
      };
   }

   static AccionInsert(onInsert: PtrnAccionFn): PtrnAccionInsert {
      return {
         label: 'Guardar',
         icon: PtrnIcons.insert,
         fn: onInsert
      };
   }
   static AccionUpdate(onUpdate: PtrnAccionFn): PtrnAccionUpdate {
      return {
         label: 'Guardar',
         icon: PtrnIcons.update,
         fn: onUpdate
      };
   }
}
